<div class="dayAndTimeSlotForm" *ngIf="calendarTimeSlotSelect">
  <div class="dateForm">
    <div>
      <label class="nodisplay">{{ 'agent:popin.create_appointment.choose_date_and_timeslot' | translate }}</label>
    </div>
    <fieldset>
      <legend (click)="clearDayTimeSlot()">{{ 'agent:popin.create_appointment.choose_day' | translate }}</legend>
      <div class="calendarPager">
        <span>
          <label class="nodisplay">{{ 'agent:popin.create_appointment.week_from' | translate }}</label>
        </span>
        <span title="{{ 'agent:popin.create_appointment.previous_week' | translate }}" class="page-changer">
          <button class="cng-ico_page_previous" (click)="addNbWeek(-1)" [disabled]="!canDisplayPreviousPage()">
            <span class="nodisplay">{{ 'agent:popin.create_appointment.previous_week' | translate }}</span>
          </button>
        </span>
        <span class="infoDate">
          <span>
            <time [attr.datetime]="convertDateToIso8601(calendarTimeSlotSelect.startOfWeek)">{{ calendarTimeSlotSelect.startOfWeek }}</time>
          </span>
          <span class="to-seperator">{{ 'agent:popin.create_appointment.to' | translate }}</span>
          <span>
            <time [attr.datetime]="convertDateToIso8601(calendarTimeSlotSelect.endOfWeek)">{{ calendarTimeSlotSelect.endOfWeek }}</time>
          </span>
          <span aria-hidden="true" class="cng-ico_calendar"></span>
        </span>
        <span title="{{ 'agent:popin.create_appointment.next_week' | i18next }}" class="page-changer">
          <button class="cng-ico_page_next" (click)="addNbWeek(1)" [disabled]="!canDisplayNextPage()">
            <span class="nodisplay">{{ 'agent:popin.create_appointment.next_week' | translate }}</span>
          </button>
        </span>
      </div>
      <div class="fieldsetDaySelect">
        <ul>
          <li
            *ngFor="let timeSlotSelect of calendarTimeSlotSelect.dayTimeSlotToPrint; let i = index"
            [class.active]="selectedTimeSlotSelect === timeSlotSelect"
          >
            <input
              type="radio"
              name="selectDay"
              [value]="timeSlotSelect"
              id="{{ 'selectDay' + i }}"
              (change)="resetDayTimeSlot(timeSlotSelect)"
            />
            <label for="{{ 'selectDay' + i }}">
              <time [attr.datetime]="convertDateToIso8601(timeSlotSelect.daySt)">{{ timeSlotSelect.daySt }}</time>
            </label>
          </li>
        </ul>
      </div>
    </fieldset>
  </div>
  <div class="timeSlotForm" *ngIf="selectedTimeSlotSelect">
    <fieldset>
      <legend (click)="clearTimeSlot()">{{ 'agent:popin.create_appointment.choose_time_slot' | translate }}</legend>
      <div class="fieldsetTimeSlotSelect">
        <ul>
          <li *ngFor="let timeSlot of selectedTimeSlotSelect.timeSlots; let i = index" [class.active]="selectedTimeSlot === timeSlot">
            <input
              type="radio"
              name="selectTimeslot"
              [value]="timeSlot"
              id="{{ 'selectTimeSlot' + i }}"
              [disabled]="!isValidTimeSlot(timeSlot)"
              (change)="notifySelectedTimeSlot(timeSlot)"
            />
            <label for="{{ 'selectTimeSlot' + i }}" [innerHTML]="readableTimeSlotSelect(timeSlot)"></label>
          </li>
        </ul>
      </div>
    </fieldset>
  </div>
</div>
<div class="appointmentResume" *ngIf="selectedTimeSlot">
  <p class="cng-ico_label_date titleAppointmentResume">
    {{ 'agent:popin.create_appointment.your_appointment' | translate }}
  </p>
  <div class="descAppointmentResume">
    <span>
      <time [attr.datetime]="convertDateToIso8601(selectedTimeSlotSelect.daySt)">
        {{ selectedTimeSlotSelect.daySt }}
      </time>
    </span>
    <span [innerHTML]="readableTimeSlotSelectWithoutContactThreshold(selectedTimeSlot)"></span>
  </div>
</div>
